module.exports = __webpack_public_path__ + "media/images/logo_white-d287ff308c8a7c1672b4b12a122f81dd.png";